import { render, staticRenderFns } from "./Anchoring_program.vue?vue&type=template&id=1d0e2450&scoped=true&"
import script from "./Anchoring_program.vue?vue&type=script&lang=js&"
export * from "./Anchoring_program.vue?vue&type=script&lang=js&"
import style0 from "./Anchoring_program.vue?vue&type=style&index=0&id=1d0e2450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0e2450",
  null
  
)

export default component.exports